var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",on:{"mouseenter":_vm.pause,"mouseleave":_vm.unpause}},[_c('transition',{attrs:{"name":"slide-in-left"}},[_vm._l((_vm.slides),function(slide,i){return [(i === _vm.value)?_c('div',{key:i},[_vm._t("default",null,{"slide":slide})],2):_vm._e()]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }